import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { thunk } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import sagas from '../sagas/rootSaga';
import rootReducer from '../reducers/rootReducer';

export default function configureStore() {
  const sagaMiddleware = createSagaMiddleware();

  const store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(sagaMiddleware, thunk))
  );

  // Run sagas
  sagaMiddleware.run(sagas);

  return store;
}
